import { render, staticRenderFns } from "./ModalOffboard.vue?vue&type=template&id=5fffd396&scoped=true"
import script from "./ModalOffboard.vue?vue&type=script&lang=js"
export * from "./ModalOffboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fffd396",
  null
  
)

export default component.exports